import { Injectable } from '@angular/core';
import { throwMatDialogContentAlreadyAttachedError } from '@angular/material';

@Injectable()

export class Configuration {
    public userData = JSON.parse(localStorage.getItem('user'))
    public protocol = 'http';
    public Server = this.protocol + '://localhost:8080/';
    public ApiUrl = 'api/';
    public ServerWithApiUrl = this.Server + this.ApiUrl;
    public ApiKey= this.userData['ApiKey']
}
